/**
 * Whether the current user may change the session they are looking at. The rule lives in
 * userToSessionWriteAccess; this hook only supplies the signed-in user.
 */

import { useAppSelector } from '../store/store';
import { Session, SessionListDTO } from '../store/sessionSlice';
import { SessionWriteAccess, userToSessionWriteAccess } from '../utils/sessionWriteAccess';

export type { SessionWriteAccess } from '../utils/sessionWriteAccess';

export const useSessionWriteAccess = (
  session?: Session | SessionListDTO | null,
): SessionWriteAccess => {
  const { alias, isAdmin, isAuditor, sites, siteCode } = useAppSelector((state) => state.user);

  return userToSessionWriteAccess({ alias, isAdmin, isAuditor, sites, siteCode })(session);
};
